import React, { useState } from 'react';
import { IconButton, Popover, CircularProgress, Box } from '@mui/material';
import { Image } from '@mui/icons-material';
import { getFileUploadUrl } from '../project.api';

interface PreviewPopoverIconProps {
  blobName: string;
}

const PreviewPopoverIcon: React.FC<PreviewPopoverIconProps> = ({ blobName }) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [previewUrl, setPreviewUrl] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const [imageLoaded, setImageLoaded] = useState(false);

  const handleClick = async (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);

    if (!previewUrl) {
      setLoading(true);
      try {
        const url = await getFileUploadUrl(blobName);
        setPreviewUrl(url);
        setImageLoaded(false);
      } catch (err) {
        console.error('Failed to fetch preview image', err);
      } finally {
        setLoading(false);
      }
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <IconButton size='small' onClick={handleClick} color='primary'>
        <Image fontSize='small' />
      </IconButton>
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        transformOrigin={{ vertical: 'top', horizontal: 'center' }}
        PaperProps={{
          sx: { minWidth: 200, background: 'white', padding: 1, border: '0.5px solid #e1e1e1', boxShadow: 3 },
        }}
      >
        {loading ? (
          <Box display='flex' justifyContent='center' alignItems='center' m={2}>
            <CircularProgress size={24} />
          </Box>
        ) : previewUrl ? (
          <>
            {!imageLoaded && (
              <Box display='flex' justifyContent='center' alignItems='center' minWidth={180} minHeight={150} position='relative'>
                <CircularProgress size={24} />
              </Box>
            )}
            <Box
              component='img'
              src={previewUrl}
              alt='Preview'
              onLoad={() => setImageLoaded(true)}
              sx={{
                display: imageLoaded ? 'block' : 'none',
                width: '100%',
                maxHeight: 180,
                objectFit: 'contain',
                borderRadius: 1,
              }}
            />
          </>
        ) : (
          <Box p={2}>Image unavailable</Box>
        )}
      </Popover>
    </>
  );
};

export default PreviewPopoverIcon;
